import { IconCommunicationMessage16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC, type SyntheticEvent, useCallback } from 'react';

import { CardNarrowMenuItem } from '../../../../components/CardNarrowMenuItem';
import { ChatButtonRendererContainer } from '../../../ChatButtonRendererContainer';

export const MenuItemChatsContainer: FC = () => {
  const render = useCallback(
    ({ onClick }: { onClick: () => void; loading: boolean }): JSX.Element => (
      <CardNarrowMenuItem
        icon={<IconCommunicationMessage16 />}
        title="Написать"
        onClick={(e: SyntheticEvent) => {
          e.stopPropagation();
          onClick();
        }}
      />
    ),
    [],
  );

  return <ChatButtonRendererContainer render={render} />;
};
